import { useState, useEffect, useRef } from "react";
import { getAllTikTokVideos } from "../firebase/firebase-functions";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import TikTokEmbed from "./TikTokEmbed";
import "./tiktoksection.css";

const TikTokSection = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    setLoading(true);
    setError("");

    try {
      const result = await getAllTikTokVideos();

      if (result.success) {
        // Only show active videos that have embedHtml
        const activeVideos = result.videos.filter(
          (v) => v.isActive && v.embedHtml,
        );

        console.log("Fetched videos:", activeVideos.length);

        setVideos(activeVideos);
      } else {
        setError(result.error || "Failed to load videos");
      }
    } catch (err) {
      setError("Failed to load videos");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 350; // Width of one video card
      const newScrollPosition =
        scrollContainerRef.current.scrollLeft +
        (direction === "left" ? -scrollAmount : scrollAmount);

      scrollContainerRef.current.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
    }
  };

  // Don't render if no videos
  if (!loading && videos.length === 0) {
    return null;
  }

  return (
    <section className="tiktok-section">
      <div className="container">
        <div className="tiktok-header">
          <h2>Behind the Scenes</h2>
          <p>Follow my musical journey on TikTok</p>
        </div>

        {loading ? (
          <div className="tiktok-loading">
            <div className="loader"></div>
            <p>Loading videos...</p>
          </div>
        ) : error ? (
          <div className="tiktok-error">
            <p>{error}</p>
          </div>
        ) : (
          <div className="tiktok-carousel-wrapper">
            {/* Navigation Arrows - Desktop Only */}
            <button
              className="tiktok-arrow tiktok-arrow-left"
              onClick={() => scroll("left")}
              aria-label="Scroll left"
            >
              <FaChevronLeft />
            </button>

            {/* Scrollable Container */}
            <div className="tiktok-scroll-container" ref={scrollContainerRef}>
              {videos.map((video) => (
                <div key={video.id} className="tiktok-video-card">
                  <div className="tiktok-embed-wrapper">
                    {/* Use TikTokEmbed component to properly render the blockquote */}
                    <TikTokEmbed embedHtml={video.embedHtml} />
                  </div>
                </div>
              ))}
            </div>

            <button
              className="tiktok-arrow tiktok-arrow-right"
              onClick={() => scroll("right")}
              aria-label="Scroll right"
            >
              <FaChevronRight />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default TikTokSection;
